import React, { useEffect } from 'react';
import StudioHeader from '../components/StudioHeader';
import HeroStudio from '../components/HeroStudio';
import StudioPossibilities from '../components/StudioPossibilities';
import StudioManifesto from '../components/StudioManifesto';
import StudioScenarios from '../components/StudioScenarios';
import StudioAudience from '../components/StudioAudience';
import MarketDoesntSee from '../components/StudioMarketDoesntSee';
import StudioExperience from '../components/StudioExperience';
import GoogleReviews from '../components/StudioGoogleReviews';
import WaitlistSection from '../components/WaitlistSection';
import StudioConstruction from '../components/StudioConstruction';
import StudioFooter from '../components/StudioFooter';
import WhatsAppFloat from '../components/WhatsAppFloat';
import { useDocumentSEO } from '../utils/useDocumentSEO';

/**
 * StudioLandingPage — Preview privada de rebrand (rota /studio).
 * NÃO INDEXADA, NÃO LINKADA na home pública. Pronta para virar HomePage
 * quando o cliente decidir ativar o Coutin Studio publicamente.
 */
const StudioLandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useDocumentSEO({
    title: 'Coutin Studio (Preview) — Chegando em 2027',
    description: 'Preview interna do rebrand Coutin Studio.',
    canonical: 'https://www.agenciacoutin.com.br/studio',
  });

  // Set noindex meta so this preview is never crawled by Google
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      document.head.appendChild(meta);
    }
    const prev = meta.getAttribute('content');
    meta.setAttribute('content', 'noindex, nofollow');
    return () => {
      // Restore when leaving the route
      if (prev) meta.setAttribute('content', prev);
      else meta.remove();
    };
  }, []);

  return (
    <div className="App bg-[#0B0B0F] text-[#F5F5F5]" style={{ fontFamily: 'Inter, sans-serif' }}>
      <StudioHeader />
      <main>
        <HeroStudio />
        <StudioPossibilities />
        <StudioManifesto />
        <StudioScenarios />
        <StudioAudience />
        <MarketDoesntSee />
        <StudioExperience />
        <GoogleReviews />
        <WaitlistSection />
        <StudioConstruction />
      </main>
      <StudioFooter />
      <WhatsAppFloat />
    </div>
  );
};

export default StudioLandingPage;
